var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("pulse-loader", {
        staticClass: "text-center",
        attrs: { loading: _vm.loading, color: _vm.$constants.LOADING_COLOR },
      }),
      _vm._v(" "),
      !_vm.loading && _vm.storeData
        ? _c("div", [
            _c(
              "div",
              { staticClass: "mt-1" },
              [
                _c("DrugInfo", {
                  ref: "drugInfo",
                  attrs: { drug: _vm.drug, locality: _vm.$editNewOrder },
                }),
                _vm._v(" "),
                _c("OrderPriceLine", {
                  attrs: {
                    drug: _vm.drug,
                    divId: _vm.divisionId,
                    actualPrice: _vm.actualPrice,
                    showCoolCondition: true,
                  },
                }),
                _vm._v(" "),
                _c("div", { staticClass: "mt-1 mb-1" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-outline-info btn-xs",
                      attrs: { type: "button" },
                      on: {
                        click: () =>
                          _vm.sendDrugMessage({
                            ..._vm.drug,
                            actualPrice: _vm.actualPrice,
                            prices: _vm.drugPrices,
                          }),
                      },
                    },
                    [
                      _c("i", { staticClass: "icon-fa icon-fa-arrow-left" }),
                      _vm._v(" Отправить препарат в\n          чат\n        "),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-outline-success btn-xs mt-1",
                      attrs: { type: "button" },
                      on: {
                        click: () =>
                          _vm.addDrugToOrder({
                            ..._vm.drug,
                            qty: 1,
                            actual_price: _vm.actualPrice,
                            price: _vm.actualPrice,
                            prices: _vm.drugPrices,
                          }),
                      },
                    },
                    [
                      _c("i", { staticClass: "icon-fa icon-fa-arrow-down" }),
                      _vm._v(" добавить в\n          заявку\n        "),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("RecommendedDeliveryDate", {
                  attrs: {
                    deliveryDate: _vm.deliveryDate,
                    cityId: _vm.selectedCityId,
                  },
                }),
              ],
              1
            ),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }